import { useState } from 'react'

import StepBar from './components/StepBar'
import {
  FirstStep,
  SecondStep,
  ThirdStep,
  FourthStep,
  FinishStep,
  ErrorStep
} from './components/FormSteps'

import * as S from './styles'

export const ContactForm = () => {
  const [currentStep, setCurrentStep] = useState(1)
  const [isFinished, setIsFinished] = useState(false)
  const [submitError, setSubmitError] = useState(false)

  const goToNextStep = () => {
    setCurrentStep(prev => Math.min(prev + 1, 4))
  }

  const goToPreviousStep = () => {
    setCurrentStep(prev => Math.max(prev - 1, 1))
  }

  const handleSubmit = () => {
    if (currentStep < 4) {
      goToNextStep()
      return
    }

    setIsFinished(true)
  }

  const renderStep = () => {
    if (submitError) return <ErrorStep />
    if (isFinished) return <FinishStep />

    switch (currentStep) {
      case 1:
        return (
          <FirstStep
            handlePreviousStep={goToPreviousStep}
            handleNextStep={goToNextStep}
          />
        )
      case 2:
        return (
          <SecondStep
            handlePreviousStep={goToPreviousStep}
            handleNextStep={goToNextStep}
          />
        )
      case 3:
        return (
          <ThirdStep
            handlePreviousStep={goToPreviousStep}
            handleNextStep={goToNextStep}
          />
        )
      case 4:
        return (
          <FourthStep
            handlePreviousStep={goToPreviousStep}
            handleNextStep={handleSubmit}
            setSubmitError={setSubmitError}
          />
        )
      default:
        return null
    }
  }

  return (
    <S.ContactFormBox className="pd mw mx-auto">
      <StepBar
        currentStep={currentStep}
        totalSteps={4}
        isFinished={isFinished}
      />
      {renderStep()}
    </S.ContactFormBox>
  )
}
